exports = module.exports = require("../../../../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Applies styles for users in high contrast mode. Note that this only applies\n * to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n * attribute, however Chrome handles high contrast differently.\n */\n/* Theme for the ripple elements.*/\n/* stylelint-disable material/no-prefixes */\n/* stylelint-enable */\n.fuse-card {\n  max-width: 430px !important;\n  min-width: 430px !important; }\n.photoImg {\n  width: 25%;\n  height: 16%;\n  padding: 4px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/questionaire/questionaire.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/questionaire/questionaire.component.scss
// module chunks = main